'use client';

import { c as _c } from "react/compiler-runtime";
import WebsiteTile from '@/components/WebsiteTile';
import { useExternalLinkTracking } from '@/hooks/useExternalLinkTracking';
interface WebsiteTileTrackedProps {
  title: string;
  description: string;
  href: string;
  imageSrc: string;
  className?: string;
}
export function WebsiteTileTracked(props) {
  const $ = _c(7);
  const trackExternalLink = useExternalLinkTracking();
  let t0;
  if ($[0] !== props.href || $[1] !== props.title || $[2] !== trackExternalLink) {
    t0 = () => trackExternalLink(props.href, `craft_website_${props.title}`);
    $[0] = props.href;
    $[1] = props.title;
    $[2] = trackExternalLink;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const trackWebsiteTileOpen = t0;
  let t1;
  if ($[4] !== props || $[5] !== trackWebsiteTileOpen) {
    t1 = <WebsiteTile {...props} onClick={trackWebsiteTileOpen} />;
    $[4] = props;
    $[5] = trackWebsiteTileOpen;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}